import { Dimmer, Loader } from 'semantic-ui-react';

import styles from './styles.module.scss';

export function FullPageLoading() {
  return (
    <Dimmer active className={styles.dimmer}>
      <Loader className={styles.loader} />
    </Dimmer>
  );
}
